import React from 'react';
import EntityTab from '../../controls/EntityTab';

export default function FeeTypes() {
    return <EntityTab entityType={'FeeTypes'} />;
}
